module.exports = __webpack_public_path__ + "img/MAG QR-code.3c23e68d.png";